import { FormOutlined } from "@ant-design/icons";
import { Space, Form } from "antd";
import { ColumnsType } from "antd/lib/table";
import { AddBannerModal, EditBannerModal, MenuPage } from "components";
import React, { useState } from "react";
import "./style.scss";
import { api } from "services/api";

export const ManageBanners: React.FC = () => {
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [currentBannerInfo, setCurrentBannerInfo] = useState<any>();
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();
	const getUpdatedInfo = async (id: string) => {
		const {
			data: {
				data: { banner },
			},
		} = await api.get(`/banners/${id}`);
		setCurrentBannerInfo(banner);
	};
	const columns: ColumnsType<any> = [
		{
			title: "Título do banner",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: () => {
				return {
					width: "12%",
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Ordem",
			dataIndex: "order",
			key: "order",
			render: (order) => <p style={{ margin: 0 }}>{order}</p>,
		},
		{
			title: "URL",
			dataIndex: "url",
			key: "url",
			render: (url) => <p style={{ margin: 0 }}>{url}</p>,
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	const handleClickAdd = () => { setIsOpen(true)}
	const handleRefresh = () => {
		setRefreshTable(true);
		setTimeout(() => {
		  	setRefreshTable(false);
		}, 1000);
	};
	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.banners;
	}

	return (
		<div className="banners">
			<AddBannerModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				onCreated={handleRefresh}
			/>
			<EditBannerModal
				form={editForm}
				setIsOpen={setIsOpenEdit}
				isOpen={isOpenEdit}
				currentBannerInfo={currentBannerInfo}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				onUpdated={handleRefresh}
			/>

			<MenuPage 
				title="Banners" 
				tableColumns={columns} 
				sourceDataUrl={'/banners'}  
				getDataFromResponse={getTableDataFromResponse} 
				addButtonText="+ Adicionar Banner" 
				onClickAdd={handleClickAdd} 
				refreshData={refreshTable}
				searchPlaceholder="Busque por título ou descrição"
			/>
		</div>
	);
};
